import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home/index.vue'),
    meta: {
      title: '首页',
    },
  },
  {
    path: '/article',
    name: 'article',
    component: () => import('@/views/article/index.vue'),
    meta: {
      title: '非遗咨询',
    },
  },
  {
    path: '/training',
    name: 'training',
    component: () => import('@/views/training/index.vue'),
    meta: {
      title: '非遗培训',
    },
  },
  {
    path: '/training/trainingList',
    name: 'trainingList',
    component: () => import('@/views/training/trainingList.vue'),
    meta: {
      title: '培训课程',
    },
  },
  {
    path: '/training/trainingDetails',
    name: 'trainingDetails',
    component: () => import('@/views/training/trainingDetails.vue'),
    meta: {
      title: '培训详情',
    },
  },
  {
    path: '/training/signUp',
    name: 'signUp',
    component: () => import('@/views/training/signUp.vue'),
    meta: {
      title: '培训报名',
    },
  },
  {
    path: '/college',
    name: 'college',
    component: () => import('@/views/college/index.vue'),
    meta: {
      title: '非遗学院',
    },
  },
  {
    path: '/college/course',
    name: 'course',
    component: () => import('@/views/college/course.vue'),
    meta: {
      title: '非遗课程',
    },
  },
  {
    path: '/college/courseDetails',
    name: 'college',
    component: () => import('@/views/college/courseDetails.vue'),
    meta: {
      title: '课程详情',
    },
  },
  {
    path: '/college/study',
    name: 'study',
    component: () => import('@/views/college/study.vue'),
    meta: {
      title: '模拟练习',
    },
  },
  {
    path: '/college/studyVideo',
    name: 'study',
    component: () => import('@/views/college/studyVideo.vue'),
    meta: {
      title: '视频',
    },
  },
  {
    path: '/college/practice',
    name: 'study',
    component: () => import('@/views/college/practice.vue'),
    meta: {
      title: '练习',
    },
  },
  {
    path: '/college/exam',
    name: 'exam',
    component: () => import('@/views/college/exam.vue'),
    meta: {
      title: '考试',
    },
  },
  {
    path: '/college/examEnd',
    name: 'exam',
    component: () => import('@/views/college/examEnd.vue'),
    meta: {
      title: '考试结果',
    },
  },
  {
    path: '/master',
    name: 'master',
    component: () => import('@/views/master/index.vue'),
    meta: {
      title: '非遗简志',
    },
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/about/index.vue'),
    meta: {
      title: '关于我们',
    },
  },
  {
    path: '/articleDetails',
    name: 'articleDetails',
    component: () => import('@/views/article/articleDetails.vue'),
    meta: {
      title: '资讯详情',
    },
  },
  {
    path: '/paidNews',
    name: 'paidNews',
    component: () => import('@/views/paidNews/index.vue'),
    meta: {
      title: '付费资讯',
    },
  },
  {
    path: '/shopping',
    name: 'shopping',
    component: () => import('@/views/shopping/index.vue'),
    meta: {
      title: '在线商城',
    },
  },
  {
    path: '/shoppingCart',
    name: 'shoppingCart',
    component: () => import('@/views/shopping/cart.vue'),
    meta: {
      title: '购物车',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 返回之前的位置（比如浏览器前进或后退时）
      return savedPosition
    } else {
      // 跳转到页面顶部
      return { x: 0, y: 0 }
    }
  },
})

export default router
